export default __webpack_public_path__ + "static/media/body.443d96d6.png";